module.exports = __webpack_public_path__ + "static/media/type-4.4bd4022e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/type-4.png
// module id = 1124
// module chunks = 0